<template>
  <Photos year="2018" :min-date="1522069200" :max-date="1522850399" date-text="March 27&ndash;31" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
